<template>
	<div class="container-fluid" id="profile_section">
		<div>
			<div class="row gold text-center">
				<div class="col-12">
					<h2>
						<i class="fas fa-users pr-1"></i>
						<span v-text=challenge></span> Coopetition Board
					</h2>
				</div>
			
			</div> <hr style="margin-bottom: 0px;">
			<div v-if="resources !== 'null'" class="row gold text-center">	
				<a class="resources-link" :href="resources" target="_blank">Resources</a>
			</div>

			<div class="row">
		
			<div v-if="video !== ''" class="col-lg video-wrapper d-flex justify-content-center">	
				<b-embed 
				class="youtube"
				:src="'https://www.youtube.com/embed/' + video + '?rel=0'"
				allowfullscreen
				aspect="16by9"		
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				></b-embed>		
			</div>
			<div v-if="chat !== 'false'" class="col pr-0 pl-0">
				<div class="wrapper">
				<div>
					<p class="mt-2" style="text-align: center; color: grey;" v-if="replies === null">It's empty here - start a discussion!</p>
					<b-list-group
					v-for="item in replies"
					:key="item.id"
					id="members_sharing"
					class="text-left mb-2">

					<b-list-group-item style="padding: 0px; border: 0px;">
						<div v-if="item.user_id === $store.state.profile.id && item.main_text != null" class="container darker">		
							<img v-if="item.profile_image != null" :src="item.profile_image" alt="Avatar">
							<img v-else src="https://media.iamconnected.com/profile_images/default.png" alt="Avatar">
							<button @click="chatThreadModal(item)" title="Thread" class="btn thread threadBtn">
								<b-badge v-if="item.replies > 0" class="threadBadge" variant="danger"> {{ item.replies }} </b-badge>
								<i class="fas fa-solid fa-comment-dots fa-lg"></i>
							</button>
							<button @click="replyDelete(item, false)" class="btn delete"><i class="fas fa-trash-alt fa-lg"></i></button> 
							<h5 class="user">{{item.first_name}} {{item.last_name}}</h5> <span class="time">{{item.access.date}} {{item.access.time}}</span>
							<p v-html="item.main_text" class="message"></p>						
						</div>
						<div v-if="item.user_id !== $store.state.profile.id && item.main_text != null" class="container">		
							<img v-if="item.profile_image != null" :src="item.profile_image" alt="Avatar">
							<img v-else src="https://media.iamconnected.com/profile_images/default.png" alt="Avatar">
							<button @click="chatThreadModal(item)" title="Thread" class="btn thread threadBtn">
								<b-badge v-if="item.replies > 0" class="threadBadge" variant="danger"> {{ item.replies }} </b-badge>
								<i class="fas fa-solid fa-comment-dots fa-lg"></i>
							</button>
							<button v-if="$store.state.profile.level >= 90" @click="replyDelete(item, false)" class="btn delete"><i class="fas fa-trash-alt fa-lg red"></i></button>
							<h5 class="user">{{item.first_name}} {{item.last_name}}</h5> <span class="time">{{item.access.date}} {{item.access.time}}</span>
							<p v-html="item.main_text" class="message"></p>			
						</div>
					</b-list-group-item>				
					</b-list-group>
					<b-form-textarea
					class="main-text"
					v-model="main_text"
					placeholder="Enter something..."
					rows="4"
					no-resize			
					></b-form-textarea>
					<strong v-if="totalRows === 1">Challenge Chat ({{totalRows}} member)</strong>
					<strong v-else>Challenge Chat ({{totalRows}} members)</strong>
					<b-button @click="replyAdd()" class="send-button" variant="primary">Send</b-button>				
				</div>
				</div>		
			</div>									
		</div>
		<hr>
			<div class="row" id="members_wrap">
				<div class="col-md-6 my-1">
					<b-form-group class="mb-0">
						<b-input-group size="sm">
							<b-form-input
								id="filter-input"
								v-model="filter"
								type="search"
								placeholder="Search Members"
							></b-form-input>

							<b-input-group-append>
								<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
							</b-input-group-append>
						</b-input-group>
					</b-form-group>
				</div>

				<div class="col-md-3 col-5 my-1">
					<b-form-group class="mb-0">
						<b-form-select
							id="per-page-select"
							v-model="perPage"
							:options="pageOptions"
							size="sm"
						></b-form-select>
					</b-form-group>
				</div>

				<div class="col-md-3 col-7 my-1">
					<b-pagination
						v-model="currentPage"
						:total-rows="totalRows"
						:per-page="perPage"
						align="right"
						size="sm"
						class="my-0"
					></b-pagination>
				</div>

				<div class="col-12">
					<b-table
						id="connections_table"
						bordered
						responsive="md"
						:items="members_sharing"
						:busy="isBusy"
						:fields="fields"
						:filter="filter"
						:filter-included-fields="filterOn"
						@filtered="onFiltered"
						:current-page="currentPage"
						:per-page="perPage"
						:sort-by.sync="sortBy"
						:sort-desc.sync="sortDesc"
						sort-icon-left
						class="small"
						show-empty
						empty-text="There are no connections to show..."
					>
						<template v-slot:table-busy>
							<div class="text-center my-2 p-2">
								<b-spinner class="align-middle"></b-spinner>
								<br />
								<strong>Loading...</strong>
							</div>
						</template>

						<template>
							<b-tr v-if="thead_top.length > 0">
								<b-th
									v-for="(v, k) in thead_top"
									:key="k"
									:colspan="v.colspan"
									:variant="v.variant"
									:class="v.class"
								>
									<span v-text="v.text"></span>
								</b-th>
							</b-tr>
						</template>

						<template v-slot:cell(actions)="data">
							<b-dropdown size="sm" class="" toggle-class="text-decoration-none" no-caret>
								<template #button-content>
									<span>
										<i class="fas fa-angle-down gold"></i>
									</span>
								</template>

								<b-dropdown-item v-if="challengesEnabled === false">
									<router-link :to="'/dashboard/' + data.item.user_id_1" class="gold">
										View <span v-text="data.item.user_name"></span>'s Dashboard
									</router-link>
								</b-dropdown-item>

								<b-dropdown-item v-if="challengesEnabled === true">
									<router-link :to="'/profile_report/' + data.item.id" class="gold">
										View <span v-text="data.item.user_name"></span>'s Report
									</router-link>
								</b-dropdown-item>

								<b-dropdown-item>
									<router-link
										:to="`/chatbox/${data.item.id}`"
										class="gold"
									>
										Chat now
									</router-link>
								</b-dropdown-item>


							</b-dropdown>
						</template>

						<template v-slot:cell(cr_7days)="data">
							<span v-text="data.item.cr_7days"></span>
						</template>
						<template v-slot:cell(cr_total)="data">
							<span v-text="data.item.cr_total"></span>
						</template>

						<template v-slot:cell(user_score)="data">
							<router-link
								v-if="data.item.user_score > 0"
								:to="'/dashboard/' + data.item.user_id_1"
								class="d-flex"
							>
								<b-progress
									:value="data.item.user_score"
									max="100"
									show-value
									:variant="progressColour(data.item.user_score)"
									style="height: 20px; width: 150px"
									class="float-right"
								></b-progress>
							</router-link>
							
							<small
								v-for="(val, index) in data.item.score_data.type"
								:key="'score_' + index"
							>
								- <small v-text="index"></small>: <span v-text="val"></span>
							</small>
						</template>

						<template v-slot:cell(level)="data">
							<span v-text="arrayElmGet(options.levels, data.item.level)"></span>
						</template>

						<template v-slot:cell(last_session)="data">
							<span v-text="data.item.last_session.date" class="mr-1"></span>
							<span v-text="data.item.last_session.time"></span>
						</template>
					</b-table>
				</div>

				<div class="col-12 my-1">
					<b-pagination
						v-model="currentPage"
						:total-rows="totalRows"
						:per-page="perPage"
						align="right"
						size="sm"
						class="my-0"
					></b-pagination>
				</div>
				<b-modal
				id="modal-chat-thread"
				ref="modal-chat-thread"
				:title="modal.title"
				ok-title="Cancel"
				ok-only
				ok-variant="outline-primary"
				no-close-on-backdrop
				>
				
				<div class="wrapper">
					
				<div>
					<p class="mt-2" style="text-align: center; color: grey;" v-if="replies_thread === null">It's empty here - start a discussion!</p>
					<div class="loadingThread text-center gold my-2" v-if="loadingThread">
					<b-spinner class="align-middle"></b-spinner>
					<br>
					<strong>Loading...</strong>
					</div>
					<div v-if="!loadingThread">		
					<b-list-group			
					v-for="item in replies_thread"
					:key="item.id"
					id="members_sharing"
					class="text-left mb-2">				
					<b-list-group-item style="padding: 0px; border: 0px;">
						<div v-if="item.user_id === $store.state.profile.id && item.main_text != null" class="container darker">		
							<img v-if="item.profile_image != null" :src="item.profile_image" alt="Avatar">
							<img v-else src="https://media.iamconnected.com/profile_images/default.png" alt="Avatar">
							<button @click="replyDelete(item, true)" class="btn delete"><i class="fas fa-trash-alt fa-lg"></i></button> 
							<h5 class="user">{{item.first_name}} {{item.last_name}}</h5> <span class="time">{{item.access.date}} {{item.access.time}}</span>
							<p v-html="item.main_text" class="message"></p>						
						</div>
						<div v-if="item.user_id !== $store.state.profile.id && item.main_text != null" class="container">		
							<img v-if="item.profile_image != null" :src="item.profile_image" alt="Avatar">
							<img v-else src="https://media.iamconnected.com/profile_images/default.png" alt="Avatar">
							<button v-if="$store.state.profile.level >= 90" @click="replyDelete(item, true)" class="btn delete"><i class="fas fa-trash-alt fa-lg red"></i></button>
							<h5 class="user">{{item.first_name}} {{item.last_name}}</h5> <span class="time">{{item.access.date}} {{item.access.time}}</span>
							<p v-html="item.main_text" class="message"></p>			
						</div>
					</b-list-group-item>				
					</b-list-group>
					</div>
					<b-form-textarea
					class="main-text"
					v-model="main_text_thread"
					placeholder="Enter something..."
					rows="4"
					no-resize			
					></b-form-textarea>
					<strong v-if="totalRows === 1">Challenge Chat ({{totalRows}} member)</strong>
					<strong v-else>Challenge Chat ({{totalRows}} members)</strong>
					<b-button @click="chatThreadReply()" class="send-button" variant="primary">Send</b-button>				
				</div>
				</div>
				</b-modal>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import {strUtils} from '../components/FormVaildation';


export default {
	name: 'ChallengeMembers',
	components: {},
	props: {},
	data() {
		return {
			errors: {},
			members_sharing: null,
			challenge: null,
			fields: [],
			thead_top: [],
			isBusy: true,
			sortBy: null,
			sortDesc: true,
			totalRows: 0,
			currentPage: 1,
			perPage: 50,
			challengesEnabled: false,
			bool: false,
			video: null,
			chat: null,
			resources: null,
			active_challenge_id: null,
			active_thread_item: null,
			main_text: null,
			main_text_thread: null,
			replies: [],
			replies_thread: [],
    		challenge_members_email: [],
			loadingThread: false,
			
			pageOptions: [
				{ value: 50, text: 'Num to Show' },
				25,
				50,
				100,
				{ value: 500, text: 'All' },
			],
			filter: null,
			filterOn: [],
			muse: {
				file: null,
				processing: 0,
				message: '',
			},

			modal: {
				title: '',
			},
		};
	},
	methods: {
		arrayElmGet(obj, value) {
			const entries = Object.entries(obj);
			for (const v of entries) {
				if (parseInt(v[1].value) === parseInt(value)) {
					return v[1].text;
				}
			}
			return null;
		},
		challengesGet() {
			let _this = this;
			let params = new URLSearchParams();
			params.append('token', this.$store.state.session_id);
			axios({
				url: _this.$store.state.api_url + 'challengesGet',
				params: params,
			})
				.then(function (response) {
					_this.isBusy = false;
					if (response.data.status == 1) {
						_this.challenges = Object.values(response.data.challenges);
					} else {
						_this.challenges = null;
					}
					_this.totalRows = _this.challenges.length;
				})
				.catch(function () {
					console.log('Error: challengesGet.');
				});
		},
		ConnectionsGet() {
			let _this = this;
			let params = new URLSearchParams();
			params.append('token', this.$store.state.session_id);
			params.append('user_id', this.$store.state.profile.id);

			if (this.$route.params.challenge_id) {
				params.append('challenge_id', this.$route.params.challenge_id);
				this.challengesEnabled = true;
			}
		
			axios({
				url: _this.$store.state.api_url + 'ChallengeConnectionsGet',
				params: params,
			})
				.then(function (response) {
                    _this.isBusy = false;
					if (response.data.status == 1) {
						console.log('sucesss.');
						_this.members_sharing = response.data.members_sharing;										
						_this.thead_top = response.data.fields.thead_top;
						_this.fields = response.data.fields.data;						
						_this.sortBy = response.data.fields.sort.sortBy;
						_this.sortDesc = response.data.fields.sort.sortDesc;
						_this.challenge = response.data.challenge[0].name;
						_this.video = response.data.challenge[0].video;
						_this.chat = response.data.challenge[0].chat;
						_this.resources = response.data.challenge[0].resources;
						_this.active_challenge_id = response.data.challenge[0].id;
					} 
					else {
						_this.members_sharing = null;
						console.log('fail.');
					}
					
					_this.totalRows = _this.members_sharing.length;
				})
				.catch(function () {
					console.log('Error: SharedMembersGet.');
				});
		},

   		 challengeMembersEmail() {
    		let _this = this;
			_this.errors.join = '';
			_this.errors.join_class = '';
			_this.processing = 'Processing...';

			let params = new URLSearchParams();
			params.append('user_id', _this.$store.state.profile.id);
			params.append('challenge_title', _this.challenge);
			params.append('challenge_id', _this.active_challenge_id);
	
			for (const key in _this.members_sharing) {   		
				if (_this.members_sharing[key].id !== _this.$store.state.profile.id) {
					if (_this.members_sharing[key].notifications.challenge_chat === '1') {
						_this.challenge_members_email.push(_this.members_sharing[key].id);
					}
				}
			}
			params.append('challenge_member_id', _this.challenge_members_email);
			

			axios({
				url: _this.$store.state.api_url + 'challengeChatEmail',
				params: params,
			})
				.then(function () {	
					_this.errors.join = 'Email sent to challenge members!';
					_this.errors.join_class = 'text-success';
					_this.challenge_members_email = [];
					_this.processing = '';
				})
				.catch(function () {
					_this.processing = '';
					console.log('challengeMembersEmail: error');
				});
   		 },

		chatGet() {
			let _this = this;
			let params = new URLSearchParams();
			params.append('token', this.$store.state.session_id);
			params.append('readonly', 0);

			params.append('user_id', this.$route.params.challenge_id);
			params.append('forum_id', this.$route.params.challenge_id);


			params.append('category', 'challenge_chat');

			params.append('limit', 50);
			params.append('order_by', 'access');
			params.append('order_direction', 'desc');
			params.append('type', 'edit');

			
			axios({
				url: _this.$store.state.api_url + 'challengeChatGet',
				params: params,
			})
				.then(function (response) {
					_this.replies = response.data;
				})
				.catch(function (error) {
					console.log(error);
				});
		},

		chatThreadModal(item) {
			this.modal.title = item.first_name + ' Thread';
			this.chatThreadCreate(item);
			this.$bvModal.show('modal-chat-thread');
		},

		chatThreadCreate(item) {
			let _this = this;
			_this.loadingThread = true;
			let params = new URLSearchParams();
			params.append('token', _this.$store.state.session_id);
			params.append('title', item.title);
			params.append('first_name', item.first_name);
			params.append('last_name', item.last_name);
			params.append('user_id', item.user_id);
			params.append('id', item.id);
			params.append('main_text', item.main_text);
			
			axios({
				url: _this.$store.state.api_url + 'challengeChatThreadCreate',
				params: params,
			})
				.then(function (response) {
					if (response.data.status == 1) {
						_this.main_text_thread = '';
						_this.active_thread_item = response.data;
					}
					_this.main_text_thread = '';
					_this.chatThreadGet(_this.active_thread_item);
				})
				.catch(function (error) {
					console.log(error);
				});
		},

		chatThreadReply() {
			let _this = this;
			if(!strUtils.isEmpty(_this.main_text_thread)){

			_this.main_text_thread = this.replaceURLs(_this.main_text_thread);

			let params = new URLSearchParams();
			params.append('token', _this.$store.state.session_id);
			params.append('main_text', _this.main_text_thread);
			params.append('title', _this.main_text_thread);
			params.append('forum_id', _this.active_thread_item.meta.forum_id);
			
			params.append('user_id', _this.$store.state.profile.id);
			
			axios({
				url: _this.$store.state.api_url + 'challengeChatThreadReply',
				params: params,
			})
				.then(function (response) {
					if (response.data.status == 1) {
						_this.main_text_thread = '';
					}
					_this.main_text_thread = '';
					_this.chatThreadGet(_this.replies_thread);
				})
				.catch(function (error) {
					console.log(error);
				});
		}},

		chatThreadGet(item) {
			let _this = this;
			_this.loadingThread = true;

			console.log(item);

			let params = new URLSearchParams();
			params.append('token', _this.$store.state.session_id);


			params.append('forum_id', item.meta.forum_id);
			params.append('user_id', item.meta.user_id)

			params.append('category', 'challenge_chat_thread');

			params.append('limit', 50);
			params.append('order_by', 'access');
			params.append('order_direction', 'desc');
			params.append('type', 'edit');

			
			axios({
				url: _this.$store.state.api_url + 'challengeChatThreadGet',
				params: params,
			})
				.then(function (response) {
					_this.replies_thread = response.data;
					_this.active_thread_item = response.data;
					_this.loadingThread = false;
				})
				.catch(function (error) {
					console.log(error);
				});
			
		},

		replyAdd() {
			console.log('replyAdd');
			let _this = this;
			console.log(_this.main_text)
			if(!strUtils.isEmpty(_this.main_text)) {
			_this.main_text = this.replaceURLs(_this.main_text);

			let params = new URLSearchParams();
			params.append('token', _this.$store.state.session_id);
			params.append('main_text', _this.main_text);
			params.append('title', _this.main_text);
			params.append('post_id', _this.active_challenge_id);
			
			params.append('view_user_id', _this.$store.state.profile.id);

			axios({
				method: 'post',
				url: _this.$store.state.api_url + 'challengeReplyAdd',
				data: params,
			})
				.then(function (response) {
					if (response.data.status == 1) {
						_this.main_text = '';
            			_this.challengeMembersEmail();
					}
					_this.main_text = '';
					_this.chatGet();
				})
				.catch(function (error) {
					console.log(error);
				});
		}},

		replyDelete(item, thread) {
			let _this = this;
			_this.main_text = this.replaceURLs(_this.main_text);
			let params = new URLSearchParams();
			params.append('token', _this.$store.state.session_id);
			params.append('reply_id', item.id);
			params.append('reply', item);
			params.append('delete', 1);
			


			axios({
				method: 'post',
				url: _this.$store.state.api_url + 'challengeReplyDelete',
				data: params,
			})
				.then(function (response) {
					if (thread) _this.chatThreadGet(_this.active_thread_item);
					if (!thread) _this.chatGet();
					
				})
				.catch(function (error) {
					console.log(error);
				});	
		},

		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},

		replaceURLs(text) {
			if(!text) return;
			
			var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
			return text.replace(urlRegex, function (url) {
				var hyperlink = url;
				if (!hyperlink.match('^https?:\/\/')) {
				hyperlink = 'http://' + hyperlink;
				}
				return '<a href="' + hyperlink + '" style="color:#d6b674;" target="_blank" rel="noopener noreferrer">' + url + '</a>'
			});
		},
	},
	computed: {
		sortOptions() {
			return this.fields
				.filter((f) => f.sortable)
				.map((f) => {
					return { text: f.label, value: f.key };
				});
		},
		
	},
	created() {},
	mounted() {
		this.ConnectionsGet();
		this.chatGet();
	},
	watch: {},
};
</script>

<style scoped>
th.score_width {
	min-width: 180px !important;
}
th.last_session {
	min-width: 160px !important;
}
::v-deep .table thead th {
  vertical-align: middle !important;
}
.youtube {
	max-width: 956px;
	max-height: 496px;	
}

.resources-link {
	margin-bottom: 5px;
	padding-left: 15px;
}

/* Chat containers */
.container {
	border: 2px solid #dedede;
	background-color: #f1f1f1;
	border-radius: 20px;
	padding: 10px;
	margin: 5px 0;
}

/* Darker chat container */
.darker {
	border-color: #ccc;
	background-color: #ddd;
}

/* Clear floats */
.container::after {
	content: "";
	clear: both;
	display: table;
}

/* Style images */
.container img {
	float: left;
	max-width: 60px;
	width: 100%;
	margin-right: 20px;
	border-radius: 50%;
}

/* Style time text */
.time {
  	color: #999;
  	margin-bottom: 0%;
}

.message {
	margin-left: 80px;
	word-wrap: break-word;
	white-space: pre-wrap;
}

.thread {
	float: right;
	color: #d6b674;
	border: none;
	padding: 6px;
	display: flex;
}


.threadBadge {
  border-radius: 30%;
  margin-right: 5px;
  
}

.delete {
	float: right;
	color: red;
	border: none;
	padding: 6px;
	display: flex;
}

.user {
	margin: 0;	
}

.video-wrapper {	
	padding: 0;
	max-height: 500px;
}

.wrapper {
    margin: 0 auto;
    max-width: 100%;
	max-height: 500px;
	min-height: 500px;
	overflow-y:scroll;
	display: flex;
	flex-direction: column-reverse;
	padding-right: 2%;
	padding-left: 2%;
}

.main-text {
	border-top-right-radius: 15px;
	border-bottom-right-radius: 15px;
	border-top-left-radius: 15px;
	border-bottom-left-radius: 15px;
	margin-bottom: 5px;
}

.send-button {	
	margin: 0px;	
	border-top-right-radius: 15px;
	border-bottom-right-radius: 15px;
	border-top-left-radius: 15px;
	border-bottom-left-radius: 15px;
	padding: 5px;
	margin-bottom: 5px;
	float: right;
}

.a:link {
	color: #d6b674;
} 

.loadingThread {
	padding-bottom: 250px;
}

</style>
